module.exports = __webpack_public_path__ + "HP_Latex_R530_small_poster.jpg?459e249f621351df34cf8ac3f3fbb0db";